import { AppConfig } from "@/types/app";
import { getAppFromRedirectUrl } from "@/utils/appMapper";
import { hasWildcardAccess, hasModuleAccess } from "@/lib/permissions";

export interface RedirectPermissionCheckResult {
    hasAccess: boolean;
    appConfig: AppConfig | null;
}

export const checkRedirectPermissions = (
    redirectUrl: string | null | undefined,
    userPermissions: string[]
): RedirectPermissionCheckResult => {
    // If no redirect URL, no need to check
    if (!redirectUrl) {
        return { hasAccess: true, appConfig: null };
    }

    const appConfig = getAppFromRedirectUrl(redirectUrl);
    
    if (!appConfig) {
        return { hasAccess: false, appConfig: null };
    }

    if (appConfig.alwaysAccessible) {
        return { hasAccess: true, appConfig };
    }

    if (hasWildcardAccess(userPermissions)) {
        return { hasAccess: true, appConfig };
    }

    if (appConfig.requiresSuperAdmin) {
        return { hasAccess: false, appConfig };
    }

    // Check permission modules
    if (appConfig.permissionModules && appConfig.permissionModules.length > 0) {
        const hasAccess = appConfig.permissionModules.some(module => 
            hasModuleAccess(userPermissions, module)
        );
        return { hasAccess, appConfig };
    }

    return { hasAccess: false, appConfig };
};

